import { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Textarea } from '@/components/ui/textarea';
import { API_BASE } from '@/utils/api';

const err = (e) => toast.error(e.response?.data?.detail || 'Error');

export const LegalTab = () => {
  const [docs, setDocs] = useState({});
  useEffect(() => {
    ['terminos', 'privacidad'].forEach(k => axios.get(`${API_BASE}/public/legal/${k}`).then(r => setDocs(d => ({ ...d, [k]: r.data }))));
  }, []);
  const save = async (k) => {
    try {
      const { data } = await axios.put(`${API_BASE}/admin/legal/${k}`, { title: docs[k].title, content: docs[k].content });
      setDocs(d => ({ ...d, [k]: data }));
      toast.success(`Guardado (versión ${data.version})`);
    } catch (e) { err(e); }
  };
  return (
    <div className="grid md:grid-cols-2 gap-4" data-testid="legal-editor">
      {['terminos', 'privacidad'].map(k => docs[k] && (
        <div key={k} className="space-y-2">
          <Input value={docs[k].title} onChange={e => setDocs({ ...docs, [k]: { ...docs[k], title: e.target.value } })} data-testid={`legal-title-${k}`} />
          <Textarea rows={10} value={docs[k].content} onChange={e => setDocs({ ...docs, [k]: { ...docs[k], content: e.target.value } })} data-testid={`legal-content-${k}`} />
          <div className="flex items-center justify-between text-xs text-muted-foreground">
            <span>Versión {docs[k].version}. Al guardar, los nuevos registros aceptan la versión nueva.</span>
            <Button size="sm" onClick={() => save(k)} data-testid={`legal-save-${k}`}>Guardar</Button>
          </div>
        </div>
      ))}
    </div>
  );
};

export const TrialExceptionsTab = () => {
  const [rows, setRows] = useState([]);
  const [cuit, setCuit] = useState('');
  const load = () => axios.get(`${API_BASE}/admin/trial-exceptions`).then(r => setRows(r.data)).catch(err);
  useEffect(() => { load(); }, []);
  const add = async () => {
    try { await axios.post(`${API_BASE}/admin/trial-exceptions`, { cuit }); setCuit(''); toast.success('Excepción creada'); load(); }
    catch (e) { err(e); }
  };
  return (
    <div className="space-y-3 max-w-xl" data-testid="trial-exceptions">
      <p className="text-sm text-muted-foreground">Permite una nueva prueba gratis para un CUIT que ya la usó (una sola vez). Para una cuenta ya creada usá "+7 días prueba" en Suscripciones.</p>
      <div className="flex gap-2">
        <Input placeholder="CUIT (11 dígitos)" value={cuit} onChange={e => setCuit(e.target.value)} data-testid="trial-exception-cuit-input" />
        <Button onClick={add} data-testid="trial-exception-add-btn">Habilitar</Button>
      </div>
      {rows.map(r => <div key={r.cuit + r.created_at} className="text-sm border border-border rounded-xl px-3 py-2">{r.cuit} · {r.used_at ? 'usada' : 'disponible'}</div>)}
    </div>
  );
};
